import React, {Component} from "react";
import {FormControlLabel, withStyles} from "@material-ui/core";
import classNames from 'classnames';
import Checkbox from '@material-ui/core/Checkbox';

const styles = theme => ({
    input: {
        width: '100%',
    },
    wrapper:{
        paddingLeft:'8px',
        paddingRight:'8px'
    }
});

class CheckBoxInput extends Component {
    state = {
        active:     this.props.active || 1
    }

    render() {
        const { classes,  width,  fieldLabel, onChange, fieldName, value} = this.props;
        //const { active } = this.state;

        return (
            <React.Fragment>
                <div className={classNames(classes.wrapper,width)}>

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={value}
                                onChange={onChange}
                                name={fieldName}
                                color="primary"
                            />
                        }
                        label={fieldLabel}
                    />

                </div>
            </React.Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(CheckBoxInput);


// WEBPACK FOOTER //
// ./src/yeffect/formBuilder/components/CheckboxInput.js